(function() { window.GUID_55ee42f3_58ef_4376_b0f8_8808ce623129 = { getGuid: function() { return "55ee42f3-58ef-4376-b0f8-8808ce623129"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        var Account;
        (function (Account) {
            class Login extends Views.ViewBase {
                get BackgroundImageId() {
                    return this.backgroundImageId;
                }
                get BackgroundImageClass() {
                    return this.backgroundImageClass;
                }
                OnDispose() {
                    $("#form-account-login input").off('keypress');
                    $('#button-signin.g-recaptcha').off('click');
                    $('#button-signin-with-email').off('click');
                    $(`#${this.BackgroundImageId}`).remove();
                }
                OnAllCssFilesLoaded() {
                    if ($('.validation-summary-errors').length > 0) {
                        $('#button-signin-with-email').hide();
                        $('#sign-in-container').show();
                    }
                }
                constructor() {
                    super();
                    this.backgroundImageId = "cs-background-img";
                    this.backgroundImageClass = "background-img__login";
                    this.waitRECAPTCHA = null;
                    this.loginToReplacedAccountShowned = false;
                    let me = this;
                    me.SetLoginBackgroundImage();
                    CS.Views.Account.Login.Instance = me;
                    $("#form-account-login input").offon('keypress.login', function (event) {
                        // This is needed since there are 2 submit buttons on the page
                        if (event.which === 13) {
                            $('#button-signin').trigger('click');
                        }
                    });
                    $('#button-signin.g-recaptcha').offon('click.login', function () {
                        CS.Controls.BusyIndicator.Current.Show();
                        me.waitRECAPTCHA = setTimeout(() => {
                            me.SubmitLogin();
                        }, 10000);
                    });
                    CS.Controls.Button.Events.Clicked({
                        selector: "#button-forgotpassword",
                        callback: function (control, e) {
                            let url = control.$Control.data('url');
                            const separator = url.includes('?') ? '&' : '?';
                            url += separator + "email=" + encodeURIComponent($("#textbox-email-child").val());
                            console.log(url);
                            CS.Nav.Go(url);
                        },
                    });
                    // Le formulaire de login est maintenant visible par défaut.
                    //$('#button-signin-with-email').offon('click.login', function () {
                    //    $('#button-signin-with-email').hide();
                    //    //$('#sign-in-container').show();
                    //    $('#sign-in-container').slideDown(200, 'linear');
                    //    //me.ShowSignInEmail();
                    //});
                    //$(document).ready(function () {
                    //    if ($('.validation-summary-errors').length > 0) {
                    //        $('#button-signin-with-email').hide();
                    //        $('#sign-in-container').show();
                    //        //me.ShowSignInEmail();
                    //    }
                    //});
                    let recaptchaBtn = $(".captcha")[0];
                    if (recaptchaBtn != null && grecaptcha != null /* && $(".g-recaptcha").length == 0*/) {
                        grecaptcha.render(recaptchaBtn, recaptchaBtn.dataset);
                    }
                    //}
                    this.showLoginToReplacedAccountModalUrl = CS.Url.CSUrl("ShowLoginToReplacedAccountModal");
                    if (this.showLoginToReplacedAccountModalUrl) {
                        this.ShowLoginToReplacedAccountModal();
                    }
                }
                SetLoginBackgroundImage() {
                    let me = this, $backgroundImageElement = $(`#${me.BackgroundImageId}`);
                    if ($backgroundImageElement.length == 0) {
                        let backgroundImageElement = `<div id="${me.BackgroundImageId}" class="${me.BackgroundImageClass}"></div>`;
                        CS.DOM.$sectionMiddle.prepend(backgroundImageElement);
                    }
                }
                SubmitLogin() {
                    clearTimeout(this.waitRECAPTCHA);
                    $('#form-account-login').submit();
                }
                ShowSignInEmail() {
                    $('#button-signin-with-email').hide();
                    $('#sign-in-container').slideDown(200, 'linear');
                    $('#sign-in-container').show();
                    //$('#sign-in-container').css("display", "block");
                }
                ShowLoginToReplacedAccountModal() {
                    const showModalUrl = this.showLoginToReplacedAccountModalUrl;
                    const renderCondition = showModalUrl != null &&
                        !this.loginToReplacedAccountShowned;
                    if (renderCondition) {
                        CS.Controls.Popup.ShowAjaxModal(showModalUrl, null, ({ popup }) => {
                            // Popup loaded
                        }, () => {
                            // Popup closed
                            this.loginToReplacedAccountShowned = true;
                        }, false);
                    }
                }
            }
            Account.Login = Login;
            Views.PageContext.OnPageLoaded({ actionName: "login", controllerName: "account" }, () => new Login());
        })(Account = Views.Account || (Views.Account = {}));
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));
function recaptchaCallback() {
    CS.Views.Account.Login.Instance.SubmitLogin();
}

//# sourceMappingURL=account.login.js.map
